.token-group-text-modal {
  .match-option-checkbox {
    margin: 15px 0px 10px 0px;

    & + .match-option-checkbox {
      margin-top: 0px;
    }
  }
}
